import { layout } from 'src/styles/layout';
import styled, { css } from 'styled-components';

export const ImageSlidesWithProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 2rem;
  width: 100%;
`;

export const ImageShowcaseWrapper = styled.div`
  position: relative;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 16px;
`;

interface SliderContainerProps {
  currentSlide?: boolean;
  slideLayout?: 'default' | 'fullWidth';
}

export const ImageShowcaseContainer = styled.div<SliderContainerProps>`
  width: ${({ slideLayout = 'default' }) => (slideLayout === 'fullWidth' ? '100%' : '1060px')};
  height: ${({ slideLayout = 'default' }) => (slideLayout === 'fullWidth' ? 'auto' : '600px')};
  position: relative;
  margin: 0 auto;
  transition: opacity 500ms ease-in-out;

  ${(props) =>
    props.currentSlide
      ? css`
          opacity: 1;
        `
      : css`
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
          opacity: 0;
        `}

  @media (max-width: ${layout.xlg}) {
    width: ${({ slideLayout = 'default' }) => (slideLayout === 'fullWidth' ? '100%' : '800px')};
    height: ${({ slideLayout = 'default' }) => (slideLayout === 'fullWidth' ? 'auto' : '450px')};
  }
`;

export const ImageSlideBlocksListContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 2.5rem;
  align-items: start;
  justify-content: start;
`;
